import { OutputData } from '@editorjs/editorjs';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { useEditorJsField_data$key } from '__generated__/useEditorJsField_data.graphql';
import { useEditorJsField_text$key } from '__generated__/useEditorJsField_text.graphql';

export type EditorJsFieldType = {
  [key: string]: OutputData | null;
};

type Props = {
  text: useEditorJsField_text$key | null;
  data: useEditorJsField_data$key;
};

export const useEditorJsField = (props: Props) => {
  const field: EditorJsFieldType = {};

  const text = useFragment(
    graphql`
      fragment useEditorJsField_text on Text {
        blocks {
          edges {
            node {
              locale
              data
            }
          }
        }
      }
    `,
    props.text
  );

  const { languages } = useFragment(
    graphql`
      fragment useEditorJsField_data on Query {
        languages {
          locale
        }
      }
    `,
    props.data
  );

  languages.forEach(({ locale }) => {
    const data = text?.blocks?.edges.find(({ node }) => node.locale === locale)
      ?.node.data;

    field[locale] = data ? JSON.parse(data) : null;
  });

  return field;
};
